import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

export const ARRIVAL_DATE_VARIABLE_SELECTOR = '{arrival_date}';
export const SHIPPING_RATE_VARIABLE_SELECTOR = '{shipping_rate}';
export const CUTOFF_TIME_VARIABLE_SELECTOR = '{time_left}';
export const SHIP_DATE_VARIABLE_SELECTOR = '{ship_date}';
export const KEY_METAFIELD_VARIABLE_SELECTOR = '{key_metafield}';
export const INVENTORY_SNAPSHOT_VARIABLE_SELECTOR = '{inventory_snapshot}';
export const SHIPPING_ZIPCODE_VARIABLE_NAME = 'address_input';
export const SHIPPING_ZIPCODE_VARIABLE_SELECTOR = `{${SHIPPING_ZIPCODE_VARIABLE_NAME}}`;

export interface ProductPromiseFormValue extends ShopPlugin.ProductPagePromise.Config {
  zipcodeInFooterDesign?: boolean;
}
export function validateProServiceShippingPattern(variables: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    const requiredVariables = [...variables];
    const formGroup = control?.parent?.parent;
    // if (formGroup?.value?.design?.template === ShopPlugin.ProductPagePromise.DesignTemplate.MINIMAL) {
    //   requiredVariables.push(SHIPPING_ZIPCODE_VARIABLE_NAME);
    // }

    const missingVariables = Array.from(new Set(requiredVariables))
      .map((variable) => (value.includes(`${variable}`) ? null : variable))
      .filter(Boolean);
    return missingVariables.length
      ? { missingVariables: `${missingVariables.map((variable) => `{${variable}}`).join(', ')} must be included` }
      : null;
  };
}

export const getDefaultProductPageConfig = (
  pluginType: ShopPlugin.ProductPagePromise.PluginType,
): ShopPlugin.ProductPagePromise.Config => ({
  pluginType,
  design: {
    template: ShopPlugin.ProductPagePromise.DesignTemplate.MINIMAL,
    widgetTitle: 'Check shipping options',
    inputPlaceholder: 'Enter your address',
    buttonText: 'Check shipping',
    backgroundColor: '#ffffff',
    fontColor: '#000000',
    cornerRadius: 0,
    padding: 0,
    iconUrl: '',
  },
  fastestShipping: {
    enabled: false,
    hideIfLongDelivery: false,
    hideIfLongDeliveryDaysThreshold: 0,
    pattern: `Arrives on ${ARRIVAL_DATE_VARIABLE_SELECTOR} to ${SHIPPING_ZIPCODE_VARIABLE_SELECTOR}`,
    fallbackText: 'No expedited shipping options to your location',
    showPrice: false,
    showCutOffTime: false,
  },
  cheapestShipping: {
    enabled: false,
    hideIfLongDelivery: false,
    hideIfLongDeliveryDaysThreshold: 0,
    cartValueThreshold: 0,
    freeShippingPattern: `Free shipping ${ARRIVAL_DATE_VARIABLE_SELECTOR}`,
    fallbackText: 'Free shipping will be calculated on checkout',
    showOnlyFreeShipping: true,
    cheapestShippingPattern: `Cheapest shipping arrives ${ARRIVAL_DATE_VARIABLE_SELECTOR}`,
    showCutOffTime: false,
  },
  addressEntry: {
    useGeolocation: false,
    zipOnly: false,
    fallbackAddress: null,
  },
  conditions: {
    conditionsRules: [],
  },
  addWidget: {
    widgetType: ShopPlugin.ProductPagePromise.WidgetType.BLOCK,
  },
});
